function initSizeGuideTabs() {
    const roots = document.querySelectorAll('[data-size-guide]');

    if (!roots.length) {
        return;
    }

    roots.forEach((root) => {
        const tabs = Array.from(root.querySelectorAll('[data-size-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-size-panel]'));

        if (!tabs.length || !panels.length) {
            return;
        }

        const setActive = (tab) => {
            const activeKey = tab.getAttribute('data-size-tab');

            tabs.forEach((item) => {
                const isActive = item === tab;
                item.setAttribute('aria-selected', String(isActive));
                item.tabIndex = isActive ? 0 : -1;
                item.classList.toggle('bg-rose', isActive);
                item.classList.toggle('text-white', isActive);
                item.classList.toggle('bg-white', !isActive);
                item.classList.toggle('text-rose', !isActive);
            });

            panels.forEach((panel) => {
                const isActive = panel.getAttribute('data-size-panel') === activeKey;
                panel.classList.toggle('hidden', !isActive);
                panel.setAttribute('aria-hidden', String(!isActive));
            });
        };

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => setActive(tab));
        });

        const defaultTab =
            tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
            tabs[0];

        if (defaultTab) {
            setActive(defaultTab);
        }
    });
}

initSizeGuideTabs();

function initSizeGuideRegionDropdowns() {
    const tables = document.querySelectorAll('[data-size-region-table]');

    if (!tables.length) {
        return;
    }

    tables.forEach((table) => {
        const trigger = table.querySelector('[data-size-region-trigger]');
        const menu = table.querySelector('[data-size-region-menu]');
        const label = table.querySelector('[data-size-region-label]');
        const options = Array.from(
            table.querySelectorAll('[data-size-region-option]'),
        );
        const cells = Array.from(
            table.querySelectorAll('[data-size-region-cell]'),
        );

        if (!trigger || !menu || !label || !options.length || !cells.length) {
            return;
        }

        const closeMenu = () => {
            menu.classList.add('opacity-0', 'scale-95', 'pointer-events-none');
            menu.classList.remove('opacity-100', 'scale-100');
            trigger.setAttribute('aria-expanded', 'false');
        };

        const openMenu = () => {
            menu.classList.remove(
                'opacity-0',
                'scale-95',
                'pointer-events-none',
            );
            menu.classList.add('opacity-100', 'scale-100');
            trigger.setAttribute('aria-expanded', 'true');
        };

        const applyRegion = (region, regionLabel) => {
            table.setAttribute('data-size-region-table', region);
            label.textContent = regionLabel || region.toUpperCase();

            cells.forEach((cell) => {
                const value = cell.getAttribute(`data-size-${region}`);
                cell.textContent = value ?? '';
            });

            options.forEach((option) => {
                const isActive =
                    option.getAttribute('data-size-region-option') === region;
                option.classList.toggle('bg-white/10', isActive);

                const check = option.querySelector('[data-size-region-check]');
                if (check) {
                    check.classList.toggle('opacity-100', isActive);
                    check.classList.toggle('opacity-0', !isActive);
                }
            });
        };

        requestAnimationFrame(() => {
            menu.classList.remove('transition-none');
            menu.classList.add('transition-all');
        });

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();
            if (menu.classList.contains('pointer-events-none')) {
                openMenu();
            } else {
                closeMenu();
            }
        });

        options.forEach((option) => {
            option.addEventListener('click', () => {
                const region = option.getAttribute('data-size-region-option');
                
                if (region) {
                    applyRegion(region, option.querySelector('span')?.textContent);
                }

                closeMenu();
            });
        });

        document.addEventListener('click', (event) => {
            if (!table.contains(event.target)) {
                closeMenu();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeMenu();
            }
        });

        const defaultRegion =
            table.getAttribute('data-size-region-table') ||
            options[0]?.getAttribute('data-size-region-option');

        if (defaultRegion) {
            applyRegion(defaultRegion);
        }
    });
}

initSizeGuideRegionDropdowns();